import { Chip } from "@dash/form";

type Props = {
  regions: string[];
};

export const RegionChips = ({ regions }: Props) => {
  return (
    <div css={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
      {regions.slice(0, 3).map((region, index) => (
        <Chip key={index} variant="secondary">
          {region}
        </Chip>
      ))}
      {regions.length > 3 && <Chip variant="secondary">{`+${regions.length - 3}`}</Chip>}
    </div>
  );
};
